// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"b7afd749","909":"8876f7c4"}[chunkId] + ".chunk.css";
};